<template>
<v-sheet flat class="d-flex align-center mb-3">
    <v-avatar
        color="light"
        size="50"
        class="me-2">
        <v-icon color="grey lighten-1" size="36">mdi-account-circle</v-icon>
    </v-avatar>
    <div>
        <div class="font-weight-bold">{{ name }}</div>
        <div class="text-caption">{{ phone }}</div>
    </div>
</v-sheet>
</template>

<script>
export default {
    name: "CustomerAvatar",
    props: ["name", "phone"]
}
</script>